<div class="layout">
    <app-ops-header
        [sidebarHidden]="isSidebarHidden()"
        (onSidebarShow)="onSidebarShow()"
        [sidebarExtends]="isSidebarExtneds()"
        (onSidebarExtends)="onSidebarExtends()"
    ></app-ops-header>
    <app-ops-sidebar
        [sidebarHidden]="isSidebarHidden()"
        [sidebarExtends]="isSidebarExtneds()"
        (onSidebarExtends)="onSidebarExtends()"
    ></app-ops-sidebar>
    <app-ops-bottombar
        *ngIf="responsive.isXSmall()"
        [sidebarExtends]="isSidebarExtneds()"
        (onSidebarExtends)="onSidebarExtends()"
    ></app-ops-bottombar>
    <div [ngClass]="['main', responsive.screenSize]">
        <router-outlet></router-outlet>
    </div>
</div>

<app-confirmation-window
    #confirmOverlay
    [mainLabel]="
        'project-settings.prompt.no-project-opened.mainLabel' | translate
    "
    [subLabel]="
        'project-settings.prompt.no-project-opened.subLabel' | translate
    "
    [confirmLabel]="
        'project-settings.prompt.no-project-opened.confirm' | translate
    "
    [cancelLabel]="
        'project-settings.prompt.no-project-opened.cancel' | translate
    "
></app-confirmation-window>

<app-forbidden-notification></app-forbidden-notification>

<app-disconnected-snack-bar></app-disconnected-snack-bar>

<div class="buzzer-btn-round-container" *ngIf="responsive.isXSmall()">
    <div
        class="buzzer-btn"
        style="cursor: pointer"
        *ngIf="isAnyAlarmUnacked"
        (click)="onStopBuzzerClick()"
    >
        <img class="buzzer-btn-round" src="/assets/images/alarm-active.png" />
        <img
            class="buzzer-btn-round flashing"
            src="/assets/images/alarm-active-flashing.png"
        />
    </div>
    <div class="buzzer-btn" *ngIf="!isAnyAlarmUnacked">
        <img class="buzzer-btn-round" src="/assets/images/alarm-inactive.png" />
    </div>
</div>
